import { ModalBody } from '@workramp/ui';
import styled from 'styled-components';

export const CreateFromFileSettingsModalBody = styled(ModalBody)`
  padding-left: ${({ theme }) => theme.spacing(7)}px;
  padding-right: ${({ theme }) => theme.spacing(7)}px;
  padding-bottom: 0;
`;
